import { useEffect, useState } from 'react'

export const useElementIsAtTop = (ref) => {

  const [isAtTop, setIsAtTop] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        setIsAtTop(ref.current.getBoundingClientRect().top <= 100)
      }
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [ref])

  return isAtTop
}

export const usePageScroll = (amount) => {

  const [pageScrolled, setPageScrolled] = useState(false)

  useEffect(() => {
    const onPageScrollDown = () => {
      if (window.scrollY > amount) {
        setPageScrolled(true)
      } 
      else {
        setPageScrolled(false)
      }
    }
    window.addEventListener('scroll', onPageScrollDown)
    return () => window.removeEventListener('scroll', onPageScrollDown)
  },[])

  return pageScrolled
}

export const useBrowserFocus = () => {

  const [isBrowserFocused, setIsBrowserFocused] = useState(true);

  const handleVisibilityChange = () => {
    setIsBrowserFocused(!document.hidden)
  }

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  return isBrowserFocused
}

export const useWindowHeight = () => {
  
    const [windowHeight, setWindowHeight] = useState(window.innerHeight)
  
    const handleResize = () => {
      setWindowHeight(window.innerHeight)
    }
  
    useEffect(() => {
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
    }, [])
  
    return windowHeight
  }